document.addEventListener('DOMContentLoaded', function() {

  // This popup is for non-rental products only (e.g. Easter specials, postage try-ons).
  // On rental product pages IzyRent handles the booking flow via its own button —
  // targeting button[name="add"] there causes conflicts, so we exit early.
  const isRentalProduct = !!document.getElementById('bookNowBtn');
  if (isRentalProduct) return;

  const addToCartButtons = document.querySelectorAll('button[name="add"]');
  if (addToCartButtons.length === 0) return;

  const popupOverlay = document.createElement('div');
  popupOverlay.className = 'confirmation-overlay';
  popupOverlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:9999;display:none;';

  const popupContent = document.createElement('div');
  popupContent.className = 'confirmation-popup';
  popupContent.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:white;padding:20px;border-radius:5px;max-width:500px;width:90%;z-index:10000;text-align:center;';

  if (window.SAS_IS_EASTER_PRODUCT) {
    popupContent.innerHTML = `
      <h3>Pickup & Postage Notice</h3>
      <p>This Easter Special is available for Sydney pickups or Australia-wide interstate orders. If you require postage, please send us a message after your purchase to arrange shipping, as postage costs are not included. 💌</p>
      <button id="confirmYes" style="background:#582434;color:white;padding:10px 20px;border:none;border-radius:4px;margin-top:15px;cursor:pointer;">I Understand</button>
    `;
  } else {
    popupContent.innerHTML = `
      <h3>Important Notice</h3>
      <p>Before you continue, please ensure you've messaged us on Instagram recently and received confirmation for the postage try-on. If a booking is made without prior confirmation, it may need to be refunded. Send us a quick message first so we can make sure everything's confirmed for you!</p>
      <button id="confirmYes" style="background:#582434;color:white;padding:10px 20px;border:none;border-radius:4px;margin-top:15px;cursor:pointer;">Yes, I have</button>
      <button id="confirmNo" style="background:#582434;color:white;padding:10px 20px;border:none;border-radius:4px;margin-top:15px;margin-left:10px;cursor:pointer;">No, I'll message first</button>
    `;
  }

  document.body.appendChild(popupOverlay);
  popupOverlay.appendChild(popupContent);

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      popupOverlay.style.display = 'block';
    });
  });

  document.getElementById('confirmYes').addEventListener('click', function() {
    popupOverlay.style.display = 'none';
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) form.submit();
  });

  const confirmNo = document.getElementById('confirmNo');
  if (confirmNo) {
    confirmNo.addEventListener('click', function() {
      popupOverlay.style.display = 'none';
      window.open('https://www.instagram.com/sas.rentals/', '_blank');
    });
  }

});